export default __webpack_public_path__ + "img/408b3ae90c46253c9dd0f86f1ec1d9e4.gif";